import React, { useState } from "react"
import { Link } from "gatsby"

import FeatureIcon from "./featureicon"

import { unslugify } from "../../utils/text"
import { ALL_FEATURES, getFeatureCommunityText } from "../../constants/features"

const CommunityFeatures = ({ community, rareFeatures = [] }) => {
  const [showAll, setShowAll] = useState(false)

  const rareBySlug = {}
  rareFeatures.forEach(r => {
    rareBySlug[r.slug] = r
  })

  const features = ALL_FEATURES.map(f => ({
    slug: f,
    has: Boolean(community[f]),
  }))

  const hasMissingFeatures = features.some(f => !f.has)
  const visibleFeatures = showAll ? features : features.filter(f => f.has)

  return (
    <React.Fragment>
      <div id="community-features-list" className="space-y-4">
        {visibleFeatures.map(feature => {
          const rare = feature.has ? rareBySlug[feature.slug] : null

          return (
            <div key={feature.slug} className="relative flex">
              <div className="mr-3 shrink-0">
                <span
                  className={`${
                    feature.has
                      ? "bg-yellow-100 text-yellow-500"
                      : "bg-gray-100 text-gray-500"
                  } rounded-lg inline-flex p-3 ring-4 ring-white`}
                >
                  <FeatureIcon feature={feature.slug} className="h-6 w-6" />
                </span>
              </div>
              <div className="min-w-0 flex-1">
                <div className="mt-1 flex flex-wrap items-baseline gap-x-2 gap-y-1">
                  <h3 className="text-sm font-medium mb-0 shrink-0">
                    <Link
                      to={`/features/${feature.slug}/`}
                      className="focus:outline-none"
                    >
                      <span className="absolute inset-0" aria-hidden="true" />
                      {unslugify(feature.slug)}
                    </Link>
                  </h3>
                  {rare ? (
                    <span
                      className="text-xs font-medium leading-snug text-amber-800"
                      aria-label={`Rare feature: Only ${rare.percentage}% of ${rare.topicName} communities have ${rare.offerCopy}`}
                    >
                      <span aria-hidden="true">🔥 Rare: </span>
                      Only {rare.percentage}% of {rare.topicName} communities
                      have {rare.offerCopy}
                    </span>
                  ) : null}
                </div>
                <p className="mt-0 text-xs text-gray-500">
                  {getFeatureCommunityText(feature.slug, feature.has)}
                </p>
              </div>
            </div>
          )
        })}
      </div>
      {hasMissingFeatures ? (
        showAll ? (
          <button
            type="button"
            aria-expanded="true"
            aria-controls="community-features-list"
            className="text-gray-600 font-semibold text-xs opacity-75 hover:opacity-100 cursor-pointer underline-offset-2 hover:underline bg-transparent border-0 p-0 text-left mt-2"
            onClick={() => setShowAll(false)}
          >
            Show only features this community has
          </button>
        ) : (
          <button
            type="button"
            aria-expanded="false"
            aria-controls="community-features-list"
            className="text-gray-600 font-semibold text-xs opacity-75 hover:opacity-100 cursor-pointer underline-offset-2 hover:underline bg-transparent border-0 p-0 text-left mt-2"
            onClick={() => setShowAll(true)}
          >
            Show all possible features
          </button>
        )
      ) : null}
    </React.Fragment>
  )
}

export default CommunityFeatures
